import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { ApiErrorResponse } from 'services/types'

import { createResultLabel } from '..'

interface UseCreateResultLabelParams {
  resultId: string
  name: string
}

/** mutation-cache: synced by the caller (useResults onSuccess): labels, result details and activity queries */
export const useCreateResultLabel = (
  options?: Omit<UseMutationOptions<void, ApiErrorResponse, UseCreateResultLabelParams>, 'mutationFn'>
) => {
  const toast = useToast()

  return useMutation<void, ApiErrorResponse, UseCreateResultLabelParams>({
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to add label'), type: 'error' })
    },
    ...options,
    mutationFn: params => createResultLabel(params.resultId, { name: params.name })
  })
}
